$( "body" ).on( "click", "a", function(e) {
  var url = $(this).attr("href"); 
  var target = $(this).attr("target")
  e.preventDefault();
  if(target != "_blank" && url.includes("#") == false && url.includes("mailto") == false) {
    $('.pagetransition').addClass('fadeinout');
  }
  else if (target == "_blank") {
    window.open(url, '_blank');
  }
  setTimeout(function() {
    if(target != "_blank" && url != "#") {
    window.location = url;
    }
  }, 250);
});


window.onload=window.onpageshow=function() {
    $(".pagetransition").removeClass("fadeinout");
};


$('.shop-meditation-cushions').click(function() {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});


$('.full-width-swatch-change').click(function() {
  let image = $(this).data('image');
  let variant = $(this).data('variant-id');
  let parentdiv = $(this).closest('.featured-product');
  $(parentdiv).find('[name="id"]').val(variant);
  $(parentdiv).find('.product__media img').attr('srcset',image).attr('src',image);
  $('.full-width-swatch-change').removeClass('active-swatch');
  $(this).addClass('active-swatch');
  
});